import { makeCrudBuilderInitialState } from "seneca-common/utils/apiStates";

import { locationsCrudStateConfig } from "../../../consts";

const locationsMetaInitialState = makeCrudBuilderInitialState(
  locationsCrudStateConfig
);

export default locationsMetaInitialState;
